import React from "react";
import { DatasetDataInfoResponse } from "api/model/dataset/DatasetDataInfoResponse";
import { safeIdString } from "utils/utils";
import { checkIfDataInCurrentMonthExists } from "utils/time-utils";
import { useTimezone } from "hooks/useTimezone";
import { Instant } from "@js-joda/core";
import { DataDisplayType, ValueChangeIndicatorProps } from "./ValueChangeIndicatorTypes";
import ValueContainer from "./ValueContainer";
import { formatNumber, getTextColor } from "../charts/utils";
import CurrentValueTooltip from "./CurrentValueTooltip";
import NoDataInCurrentMonth from "./NoDataInCurrentMonth";

const LastValue = (
  props: ValueChangeIndicatorProps & {
    data?: DatasetDataInfoResponse[];
    refTime: Instant;
    diffDecimalPlaces?: number;
    setDialog: (isVisible: boolean) => void;
  }
) => {
  const tz = useTimezone();

  if (
    props.data &&
    props.data.length === 1 &&
    (props.dataDisplayType === DataDisplayType.LAST_VALUE || props.dataDisplayType === undefined)
  ) {
    const dataset = props.data[0];
    const val = dataset.data?.[1];
    const safeId = safeIdString(dataset.identifier);
    const tooltipId = `last-value-${safeId}-tooltip`;

    if (!val) {
      return <NoDataInCurrentMonth tz={tz.company} refTime={props.refTime} theme={props.theme} />;
    }

    const inCurrentMonth = checkIfDataInCurrentMonthExists(val.key, tz.company, props.refTime);

    if (!inCurrentMonth) {
      return <NoDataInCurrentMonth tz={tz.company} refTime={props.refTime} theme={props.theme} />;
    }

    return (
      <ValueContainer
        id={tooltipId}
        value={
          val?.value !== undefined
            ? formatNumber(val.value, props.decimalPlaces, props.convertToAbsoluteValues)
            : null
        }
        unit={!props.hideUnit ? dataset.unit : undefined}
        highlight={props.highlightValue}
        color={getTextColor(props.theme)}
        onDoubleClick={() => props.setDialog(true)}
      >
        {val?.value !== undefined && (
          <CurrentValueTooltip
            id={tooltipId}
            value={val.value}
            valueKey={val.key}
            unit={dataset.unit}
            diffDecimalPlaces={props.diffDecimalPlaces}
            tz={tz.display}
          />
        )}
      </ValueContainer>
    );
  }

  return null;
};

export default LastValue;
